import ItemCover from "components/ItemCover"
import ProductColors from "components/ProductColors"
import { ChangeEvent } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalLayout,
  SearchForm,
  Searchbar,
  Table,
  Tbody,
  Td,
  Tr,
  Typography,
} from "@strapi/design-system"
import NoItems from "../NoItems"
import PageLoader from "../PageLoader"

interface AddProductModalProps {
  isModalOpen: boolean
  setModalOpen: (isOpen: boolean) => void
  newProducts: any[]
  loadingNewProducts: boolean
  debouncedSearchText: string
  searchText: string
  setSearchText: (text: string) => void
  addProduct: (product: any, sku: any) => void
}

export const SearchProductModal = ({
  isModalOpen,
  setModalOpen,
  newProducts,
  loadingNewProducts,
  debouncedSearchText,
  searchText,
  setSearchText,
  addProduct,
}: AddProductModalProps) => {
  const { t } = useTranslation()

  return (
    isModalOpen && (
      <ModalLayout onClose={() => setModalOpen(false)} labelledBy="title">
        <ModalHeader>
          <Typography fontWeight="bold" textColor="neutral800" as="h2" id="title">
            {t("searchProductModal.addProductTitle")}
          </Typography>
        </ModalHeader>
        <ModalBody>
          <SearchForm>
            <Searchbar
              name="searchbar"
              onClear={() => setSearchText("")}
              value={searchText}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value)}
              clearLabel={t("searchProductModal.clearSearch")}
            >
              {t("searchProductModal.searchPlaceholder")}
            </Searchbar>
          </SearchForm>
          {!!newProducts.length && (
            <Table>
              <Tbody>
                {newProducts.map((product: any) => (
                  <Tr key={product.id}>
                    <Td>
                      <Box padding={1}>
                        <ItemCover cover={product.cover} />
                      </Box>
                    </Td>
                    <Td>
                      <ProductColors
                        product={product}
                        onClick={(sku: any) => addProduct(product, sku)}
                        size={32}
                      />
                    </Td>
                    <Td
                      style={{
                        maxWidth: "200px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {product.name}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
          {loadingNewProducts && <PageLoader />}
          {!newProducts.length && !loadingNewProducts && debouncedSearchText !== "" && (
            <NoItems
              text={t("searchProductModal.noProductsFound")}
              addText={t("searchProductModal.createNewProduct")}
              addLink={`/products/add`}
              showAdd
            />
          )}
        </ModalBody>
        <ModalFooter
          startActions={
            <Button onClick={() => setModalOpen(false)}>
              {t("searchProductModal.closeButton")}
            </Button>
          }
        />
      </ModalLayout>
    )
  )
}
